import { Box, Grid } from "@chakra-ui/core";
import React from "react";
import NavBar from "../../../Components/NavBar";
import SubSearchBar from "./SubSearchBar";
// import ProfileCard from "./ProfileCard";
import FilterCard from "./FilterCard";
import ShowJobs from "./ShowJobs";
// import { demoProfile } from "../../../Data/Jobs";

function JobSearch() {
  return (
    <Box>
      <NavBar />
      <SubSearchBar />

      <Grid mt="5" templateColumns="auto 2fr" gap="1em">
        {/* <ProfileCard profile={demoProfile[0]} /> */}
        <FilterCard />
        <ShowJobs />
      </Grid>
    </Box>
  );
}

export default JobSearch;
